function configAutoGrow(autoExpand, estimatedCKEditorHeight, isViewMediaPrint) {
    if (autoExpand) {
        return {
            autoGrow_minHeight: isViewMediaPrint ? undefined : estimatedCKEditorHeight,
            autoGrow_onStartup: true,
        };
    }
    return {
        height: estimatedCKEditorHeight,
    };
}

export default configAutoGrow;
